const messengerKeys = {
  all: ['messenger'] as const,
  me: () => [...messengerKeys.all, 'me'] as const,
  channelDetail: (channelId?: string) =>
    [...messengerKeys.all, 'channel-detail', channelId] as const,
  channelEnrichments: (channelUrls: string[]) =>
    [...messengerKeys.all, 'channel-enrichments', channelUrls.join(',')] as const,
  channels: () => [...messengerKeys.all, 'channels'] as const,
};

export { messengerKeys };
